import Vue from 'vue'
import VueHead from 'vue-head'

import App from './App.vue'
import router from './router'
import store from './store/index'

import GetText from './plugins/gettext'
import Capture from './plugins/capture'
import Sonification from './plugins/sonification'

import VueAnnouncer from 'vue-announcer'


require('video.js/dist/video-js.css')
require('@/assets/styles/app.scss')


Vue.use(GetText)
Vue.use(Capture)
Vue.use(VueHead)
Vue.use(Sonification)
Vue.use(VueAnnouncer);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
